import React, { createContext, useEffect } from "react";
import withLanguage from "./components/withLanguage";
import ToastNottfication, { ToastNottficationtype } from "./components/toast";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { ChangeLanguageDocumentAttributes } from "./helpers";
import AppRouter from "./router";
import { useLocation, useNavigate } from "react-router-dom";
import SplashScreen from "./views/SplashScreen";
import { toast, Toaster, ToastBar } from "react-hot-toast";
import "react-datepicker/dist/react-datepicker.css";
import "./css/datepicker.scss";
import AppNotification from "./components/toast/AppNotification";
import { useAuth } from "./context/AuthContext";
import RatingModalWrap from "./components/rating/RatingModalWrap";

interface ToastContextInterface {
  toast: null | any | ToastNottficationtype[];
  setToast: React.Dispatch<
    React.SetStateAction<any | ToastNottficationtype[] | null>
  >;
  success: (title: string, message?: string) => void;
  error: (title: string, message?: string) => void;
}
export const ToastContext = createContext<ToastContextInterface | null>(null);

function App() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [currentToast, setCurrentToast] =
    React.useState<null | any | ToastNottficationtype[]>(null);

  const showSuccessToast = (title: string) => {
    setCurrentToast([
      ...(currentToast || []),
      {
        massgesKey: title,
        type: "success",
      },
    ]);
  };

  const showErrorToast = (title: string) => {
    setCurrentToast([
      ...(currentToast || []),
      {
        massgesKey: title,
        type: "error",
      },
    ]);
  };

  const toastContext = {
    toast: currentToast,
    setToast: setCurrentToast,
    success: showSuccessToast,
    error: showErrorToast,
  };

  useEffect(() => {
    ChangeLanguageDocumentAttributes();
  }, []);

  return (
    <div className="App font-readex ">
      <ToastContext.Provider value={toastContext}>
        {!!currentToast &&
          currentToast?.length! > 0 &&
          currentToast?.map((Nottficationt: ToastNottficationtype) => {
            return (
              <ToastNottfication
                massgesKey={Nottficationt.massgesKey}
                type={Nottficationt.type}
              />
            );
          })}
        <Toaster position="top-right">
          {(t) => (
            <ToastBar toast={t}>
              {({ icon, message }) => (
                <AppNotification
                  message={message}
                  type={t.type}
                  onClose={() => toast.dismiss(t.id)}
                />
              )}
            </ToastBar>
          )}
        </Toaster>

        {!!auth?.isLoadingUser ? <SplashScreen /> : <AppRouter />}
        {process.env.REACT_APP_CURRENT_ENVIRONMENT === "develop" && (
          <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
        )}
      </ToastContext.Provider>
      <RatingModalWrap />
    </div>
  );
}

export default withLanguage(App);
